<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-autocomplete
          label="Cotista"
          hide-details

          multiple
          clearable
          small-chips
          deletable-chips

          :items="filterOptions.quotaholderName"
          :value="filters.quotaholderName"
          @change="(newValue) => updateFilters({ quotaholderName: newValue })"
        />
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          label="Cotização"
          hide-details

          multiple
          clearable
          small-chips
          deletable-chips

          :items="filterOptions.refDate"
          :value="filters.refDate"
          @change="(newValue) => updateFilters({ refDate: newValue })"
        />
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          label="Liquidação"
          hide-details

          multiple
          clearable
          small-chips
          deletable-chips

          :items="filterOptions.settlementDate"
          :value="filters.settlementDate"
          @change="(newValue) => updateFilters({ settlementDate: newValue })"
        />
      </v-col>

      <v-col cols="12">
        <v-autocomplete
          label="Critério"
          hide-details

          multiple
          clearable
          small-chips
          deletable-chips

          :items="filterOptions.redemptionCriterion"
          :value="filters.redemptionCriterion"
          @change="(newValue) => updateFilters({ redemptionCriterion: newValue })"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'QuotaholdersOperationsFilters',

  props: {
    filters: {
      type: Object,
      required: true,
    },

    filterOptions: {
      type: Object,
      required: true,
    },
  },

  watch: {
    filterOptions: {
      deep: true,
      immediate: true,
      handler(newOptions) {
        const validFilters = {};

        Object.entries(newOptions).forEach(([key, options]) => {
          validFilters[key] = this.filters[key].filter((val) => options.includes(val));
        });

        this.updateFilters(validFilters);
      },
    },
  },

  methods: {
    updateFilters(newValues) {
      this.$emit('update:filters', { ...this.filters, ...newValues });
    },
  },
};
</script>
